export class TpslRouteStates {
  public RouteNumber: number;

  public NumberOfStops: number;
  public NumberOfParcels: number;

  public SelectedDate: Date = new Date();
  public SelectedSectorID: number;
  public SelectedRouteID: number;

  public LockedRoute = new Map();
  public HiddenRoute = new Map();
}

